var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blank-layout flex justify-center items-center",attrs:{"id":"content"}},[_c('div',{staticClass:" sm:w-1/2 xl:w-1/3"},[_c('router-view',{staticClass:"z-0"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }